import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';
import { SingleAggreStyle } from './DisclaimerStyle';

const SingleAggrePremiumSection = props => {
  const {
    reprojectionsDetails: {
      indicators: { singPmtPgInd }
    },
    policyOverview: { planCode, productType, productCategory },
    planCodeList
  } = props;

  if (!singPmtPgInd || productType === "BIIP") {
    return null;
  }

  const getMessage = () => {
    if (productCategory === "Whole Life") {
      return <FormattedHTMLMessage id="disclaimerSingleAggrePremiumWOLLabel" />;
    }

    if (_.includes(planCodeList, planCode)) {
      return (
        <FormattedHTMLMessage id="disclaimerSingleAggrePremiumLabelJWIP" />
      );
    }
    return <FormattedHTMLMessage id="disclaimerSingleAggrePremiumLabel" />;
  };

  return (
    <SingleAggreStyle id="disclaimerSingleAggregatePremium">
      {singPmtPgInd && getMessage()}
    </SingleAggreStyle>
  );
};

SingleAggrePremiumSection.propTypes = {
  reprojectionsDetails: PropTypes.object.isRequired,
  policyOverview: PropTypes.object.isRequired,
  planCodeList: PropTypes.array.isRequired
};

export default SingleAggrePremiumSection;
